module.exports = __webpack_public_path__ + "static/media/redwoods.428e3f41.jpeg";